import { Badges, FeatherIcons, H4, LI, UL } from "../../../../AbstractElements";
import { yourBalanceData } from "../../../../Data/Widgets/GeneralWidgetsData";

const YourInvestment = () => {
  return (
    <UL className="flex-row simple-list">
      {yourBalanceData.map((data, i) => (
        <LI key={i}>
          <div className={`balance-item ${data.class}`}>
            <div className="balance-icon-wrap">
              <div className="balance-icon">
                <FeatherIcons iconName={data.arrow} />
              </div>
            </div>
            <div>
              <span className="f-12 f-light">{data.header}</span>
              <H4>{data.amount}</H4>
              <Badges
                color={`light-${data.class}`}
                className={`font-${data.class}`}
                pill
              >
                {data.badge}
              </Badges>
            </div>
          </div>
        </LI>
      ))}
    </UL>
  );
};

export default YourInvestment;
